import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { alchemy } from "../utils/alchemy";

function TransactionDetails() {
  const { txHash } = useParams();
  const [transaction, setTransaction] = useState(null);
  const [receipt, setReceipt] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchTransaction() {
      try {
        const txData = await alchemy.core.getTransaction(txHash);
        const receiptData = await alchemy.core.getTransactionReceipt(txHash);
        setTransaction(txData);
        setReceipt(receiptData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching transaction:", error);
        setLoading(false);
      }
    }

    fetchTransaction();
  }, [txHash]);

  if (loading) {
    return <div className="loading">Loading transaction details...</div>;
  }

  if (!transaction) {
    return <div className="error">Transaction not found</div>;
  }

  return (
    <div className="page">
      <h1>Transaction Details</h1>

      <div className="details-grid">
        <div className="detail-item full-width">
          <div className="label">Transaction Hash</div>
          <div className="value mono">{transaction.hash}</div>
        </div>

        <div className="detail-item">
          <div className="label">Status</div>
          <div className="value">
            {receipt
              ? receipt.status === 1
                ? "Success"
                : "Failed"
              : "Pending"}
          </div>
        </div>

        <div className="detail-item">
          <div className="label">Block</div>
          <div className="value">
            <Link to={`/block/${transaction.blockNumber}`}>
              {transaction.blockNumber}
            </Link>
          </div>
        </div>

        <div className="detail-item full-width">
          <div className="label">From</div>
          <div className="value mono">
            <Link to={`/address/${transaction.from}`}>{transaction.from}</Link>
          </div>
        </div>

        <div className="detail-item full-width">
          <div className="label">To</div>
          <div className="value mono">
            {transaction.to ? (
              <Link to={`/address/${transaction.to}`}>{transaction.to}</Link>
            ) : (
              "Contract Creation"
            )}
          </div>
        </div>

        <div className="detail-item">
          <div className="label">Value</div>
          <div className="value">
            {(parseInt(transaction.value._hex, 16) / 1e18).toFixed(6)} ETH
          </div>
        </div>

        <div className="detail-item">
          <div className="label">Gas Limit</div>
          <div className="value">
            {parseInt(transaction.gasLimit._hex, 16).toLocaleString()}
          </div>
        </div>

        {receipt && (
          <div className="detail-item">
            <div className="label">Gas Used</div>
            <div className="value">
              {parseInt(receipt.gasUsed._hex, 16).toLocaleString()}
            </div>
          </div>
        )}

        <div className="detail-item">
          <div className="label">Gas Price</div>
          <div className="value">
            {transaction.gasPrice
              ? (parseInt(transaction.gasPrice._hex, 16) / 1e9).toFixed(2) +
                " Gwei"
              : "N/A"}
          </div>
        </div>

        {receipt && (
          <div className="detail-item">
            <div className="label">Transaction Fee</div>
            <div className="value">
              {(
                (parseInt(receipt.gasUsed._hex, 16) *
                  parseInt(receipt.effectiveGasPrice._hex, 16)) /
                1e18
              ).toFixed(6)}{" "}
              ETH
            </div>
          </div>
        )}

        <div className="detail-item">
          <div className="label">Nonce</div>
          <div className="value">{transaction.nonce}</div>
        </div>

        <div className="detail-item full-width">
          <div className="label">Input Data</div>
          <div className="value mono">{transaction.data}</div>
        </div>
      </div>
    </div>
  );
}

export default TransactionDetails;
